import React from 'react';
import './HexListItem.css';
import { textColor } from '../../utilis';
import { Link } from "react-router-dom";
import { Col } from 'react-grid-system';

const HexListItem = (props) => (
    <Col xs={4} md={1} >
            <Link style={{ backgroundColor: `#${props.code}` }} to={props.code} className="hexlistitem" >
                <i onClick={() => props.sendToApp.sendToApp(props.code)} style={{ color: textColor(props.code) }}>#{props.code}</i>
            </Link>
    </Col>    
)

export default HexListItem


// WEBPACK FOOTER //
// ./src/components/HexListItem/HexListItem.js